import { LanguageCode } from "../../../pages/shared/components/language/types";
import queryString from "query-string";
import { ProductRefType } from "../../../context/product-context/types";

export const Params = {
  productRef: {
    key: "productRef",
    uri: (productRef: string): string =>
      `?${Params.productRef.key}=${productRef}`,
    get: (): string | undefined => {
      return new URL(window.location.href).searchParams.get(
        Params.productRef.key,
      );
    },
    update: (product: ProductRefType): string => {
      const parsedUrl = queryString.parseUrl(window.location.href);
      return queryString.stringifyUrl({
        url: window.location.href,
        query: { ...parsedUrl.query, [Params.productRef.key]: product },
      });
    },
    remove: (): string => {
      const parsedUrl = queryString.parseUrl(window.location.href);
      if (Params.productRef.key in parsedUrl.query) {
        const {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          [Params.productRef.key]: productRef,
          ...noProductRefQuery
        } = parsedUrl.query;
        return queryString.stringifyUrl({
          url: parsedUrl.url,
          query: { ...noProductRefQuery },
        });
      } else {
        return window.location.href;
      }
    },
  },
  language: {
    key: "lang",
    uri: (language: LanguageCode): string =>
      `?${Params.language.key}=${language}`,
    get: (): LanguageCode | null => {
      return new URL(window.location.href).searchParams
        .get(Params.language.key)
        ?.toLowerCase() as LanguageCode;
    },
  },
};
